export default [
  {
    name: 'Africa/Abidjan',
    value: 'Africa/Abidjan',
    offset: 0,
  },
  {
    name: 'Africa/Accra',
    value: 'Africa/Accra',
    offset: 0,
  },
  {
    name: 'Africa/Addis Ababa',
    value: 'Africa/Addis_Ababa',
    offset: 3,
  },
  {
    name: 'Africa/Algiers',
    value: 'Africa/Algiers',
    offset: 1,
  },
  {
    name: 'Africa/Asmara',
    value: 'Africa/Asmara',
    offset: 3,
  },
  {
    name: 'Africa/Bamako',
    value: 'Africa/Bamako',
    offset: 0,
  },
  {
    name: 'Africa/Bangui',
    value: 'Africa/Bangui',
    offset: 1,
  },
  {
    name: 'Africa/Banjul',
    value: 'Africa/Banjul',
    offset: 0,
  },
  {
    name: 'Africa/Bissau',
    value: 'Africa/Bissau',
    offset: 0,
  },
  {
    name: 'Africa/Blantyre',
    value: 'Africa/Blantyre',
    offset: 2,
  },
  {
    name: 'Africa/Brazzaville',
    value: 'Africa/Brazzaville',
    offset: 1,
  },
  {
    name: 'Africa/Bujumbura',
    value: 'Africa/Bujumbura',
    offset: 2,
  },
  {
    name: 'Africa/Cairo',
    value: 'Africa/Cairo',
    offset: 2,
  },
  {
    name: 'Africa/Casablanca',
    value: 'Africa/Casablanca',
    offset: 1,
  },
  {
    name: 'Africa/Ceuta',
    value: 'Africa/Ceuta',
    offset: 2,
  },
  {
    name: 'Africa/Conakry',
    value: 'Africa/Conakry',
    offset: 0,
  },
  {
    name: 'Africa/Dakar',
    value: 'Africa/Dakar',
    offset: 0,
  },
  {
    name: 'Africa/Dar es Salaam',
    value: 'Africa/Dar_es_Salaam',
    offset: 3,
  },
  {
    name: 'Africa/Djibouti',
    value: 'Africa/Djibouti',
    offset: 3,
  },
  {
    name: 'Africa/Douala',
    value: 'Africa/Douala',
    offset: 1,
  },
  {
    name: 'Africa/El Aaiun',
    value: 'Africa/El_Aaiun',
    offset: 1,
  },
  {
    name: 'Africa/Freetown',
    value: 'Africa/Freetown',
    offset: 0,
  },
  {
    name: 'Africa/Gaborone',
    value: 'Africa/Gaborone',
    offset: 2,
  },
  {
    name: 'Africa/Harare',
    value: 'Africa/Harare',
    offset: 2,
  },
  {
    name: 'Africa/Johannesburg',
    value: 'Africa/Johannesburg',
    offset: 2,
  },
  {
    name: 'Africa/Juba',
    value: 'Africa/Juba',
    offset: 3,
  },
  {
    name: 'Africa/Kampala',
    value: 'Africa/Kampala',
    offset: 3,
  },
  {
    name: 'Africa/Khartoum',
    value: 'Africa/Khartoum',
    offset: 2,
  },
  {
    name: 'Africa/Kigali',
    value: 'Africa/Kigali',
    offset: 2,
  },
  {
    name: 'Africa/Kinshasa',
    value: 'Africa/Kinshasa',
    offset: 1,
  },
  {
    name: 'Africa/Lagos',
    value: 'Africa/Lagos',
    offset: 1,
  },
  {
    name: 'Africa/Libreville',
    value: 'Africa/Libreville',
    offset: 1,
  },
  {
    name: 'Africa/Lome',
    value: 'Africa/Lome',
    offset: 0,
  },
  {
    name: 'Africa/Luanda',
    value: 'Africa/Luanda',
    offset: 1,
  },
  {
    name: 'Africa/Lubumbashi',
    value: 'Africa/Lubumbashi',
    offset: 2,
  },
  {
    name: 'Africa/Lusaka',
    value: 'Africa/Lusaka',
    offset: 2,
  },
  {
    name: 'Africa/Malabo',
    value: 'Africa/Malabo',
    offset: 1,
  },
  {
    name: 'Africa/Maputo',
    value: 'Africa/Maputo',
    offset: 2,
  },
  {
    name: 'Africa/Maseru',
    value: 'Africa/Maseru',
    offset: 2,
  },
  {
    name: 'Africa/Mbabane',
    value: 'Africa/Mbabane',
    offset: 2,
  },
  {
    name: 'Africa/Mogadishu',
    value: 'Africa/Mogadishu',
    offset: 3,
  },
  {
    name: 'Africa/Monrovia',
    value: 'Africa/Monrovia',
    offset: 0,
  },
  {
    name: 'Africa/Nairobi',
    value: 'Africa/Nairobi',
    offset: 3,
  },
  {
    name: 'Africa/Ndjamena',
    value: 'Africa/Ndjamena',
    offset: 1,
  },
  {
    name: 'Africa/Niamey',
    value: 'Africa/Niamey',
    offset: 1,
  },
  {
    name: 'Africa/Nouakchott',
    value: 'Africa/Nouakchott',
    offset: 0,
  },
  {
    name: 'Africa/Ouagadougou',
    value: 'Africa/Ouagadougou',
    offset: 0,
  },
  {
    name: 'Africa/Porto-Novo',
    value: 'Africa/Porto-Novo',
    offset: 1,
  },
  {
    name: 'Africa/Sao Tome',
    value: 'Africa/Sao_Tome',
    offset: 0,
  },
  {
    name: 'Africa/Tripoli',
    value: 'Africa/Tripoli',
    offset: 2,
  },
  {
    name: 'Africa/Tunis',
    value: 'Africa/Tunis',
    offset: 1,
  },
  {
    name: 'Africa/Windhoek',
    value: 'Africa/Windhoek',
    offset: 2,
  },
  {
    name: 'America/Adak',
    value: 'America/Adak',
    offset: -9,
  },
  {
    name: 'America/Anchorage',
    value: 'America/Anchorage',
    offset: -8,
  },
  {
    name: 'America/Anguilla',
    value: 'America/Anguilla',
    offset: -4,
  },
  {
    name: 'America/Antigua',
    value: 'America/Antigua',
    offset: -4,
  },
  {
    name: 'America/Araguaina',
    value: 'America/Araguaina',
    offset: -3,
  },
  {
    name: 'America/Argentina/Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
    offset: -3,
  },
  {
    name: 'America/Argentina/Catamarca',
    value: 'America/Argentina/Catamarca',
    offset: -3,
  },
  {
    name: 'America/Argentina/Cordoba',
    value: 'America/Argentina/Cordoba',
    offset: -3,
  },
  {
    name: 'America/Argentina/Jujuy',
    value: 'America/Argentina/Jujuy',
    offset: -3,
  },
  {
    name: 'America/Argentina/La Rioja',
    value: 'America/Argentina/La_Rioja',
    offset: -3,
  },
  {
    name: 'America/Argentina/Mendoza',
    value: 'America/Argentina/Mendoza',
    offset: -3,
  },
  {
    name: 'America/Argentina/Rio Gallegos',
    value: 'America/Argentina/Rio_Gallegos',
    offset: -3,
  },
  {
    name: 'America/Argentina/Salta',
    value: 'America/Argentina/Salta',
    offset: -3,
  },
  {
    name: 'America/Argentina/San Juan',
    value: 'America/Argentina/San_Juan',
    offset: -3,
  },
  {
    name: 'America/Argentina/San Luis',
    value: 'America/Argentina/San_Luis',
    offset: -3,
  },
  {
    name: 'America/Argentina/Tucuman',
    value: 'America/Argentina/Tucuman',
    offset: -3,
  },
  {
    name: 'America/Argentina/Ushuaia',
    value: 'America/Argentina/Ushuaia',
    offset: -3,
  },
  {
    name: 'America/Aruba',
    value: 'America/Aruba',
    offset: -4,
  },
  {
    name: 'America/Asuncion',
    value: 'America/Asuncion',
    offset: -4,
  },
  {
    name: 'America/Atikokan',
    value: 'America/Atikokan',
    offset: -5,
  },
  {
    name: 'America/Bahia',
    value: 'America/Bahia',
    offset: -3,
  },
  {
    name: 'America/Bahia Banderas',
    value: 'America/Bahia_Banderas',
    offset: -5,
  },
  {
    name: 'America/Barbados',
    value: 'America/Barbados',
    offset: -4,
  },
  {
    name: 'America/Belem',
    value: 'America/Belem',
    offset: -3,
  },
  {
    name: 'America/Belize',
    value: 'America/Belize',
    offset: -6,
  },
  {
    name: 'America/Blanc-Sablon',
    value: 'America/Blanc-Sablon',
    offset: -4,
  },
  {
    name: 'America/Boa Vista',
    value: 'America/Boa_Vista',
    offset: -4,
  },
  {
    name: 'America/Bogota',
    value: 'America/Bogota',
    offset: -5,
  },
  {
    name: 'America/Boise',
    value: 'America/Boise',
    offset: -6,
  },
  {
    name: 'America/Cambridge Bay',
    value: 'America/Cambridge_Bay',
    offset: -6,
  },
  {
    name: 'America/Campo Grande',
    value: 'America/Campo_Grande',
    offset: -4,
  },
  {
    name: 'America/Cancun',
    value: 'America/Cancun',
    offset: -5,
  },
  {
    name: 'America/Caracas',
    value: 'America/Caracas',
    offset: -4,
  },
  {
    name: 'America/Cayenne',
    value: 'America/Cayenne',
    offset: -3,
  },
  {
    name: 'America/Cayman',
    value: 'America/Cayman',
    offset: -5,
  },
  {
    name: 'America/Chicago',
    value: 'America/Chicago',
    offset: -5,
  },
  {
    name: 'America/Chihuahua',
    value: 'America/Chihuahua',
    offset: -6,
  },
  {
    name: 'America/Costa Rica',
    value: 'America/Costa_Rica',
    offset: -6,
  },
  {
    name: 'America/Creston',
    value: 'America/Creston',
    offset: -7,
  },
  {
    name: 'America/Cuiaba',
    value: 'America/Cuiaba',
    offset: -4,
  },
  {
    name: 'America/Curacao',
    value: 'America/Curacao',
    offset: -4,
  },
  {
    name: 'America/Danmarkshavn',
    value: 'America/Danmarkshavn',
    offset: 0,
  },
  {
    name: 'America/Dawson',
    value: 'America/Dawson',
    offset: -7,
  },
  {
    name: 'America/Dawson Creek',
    value: 'America/Dawson_Creek',
    offset: -7,
  },
  {
    name: 'America/Denver',
    value: 'America/Denver',
    offset: -6,
  },
  {
    name: 'America/Detroit',
    value: 'America/Detroit',
    offset: -4,
  },
  {
    name: 'America/Dominica',
    value: 'America/Dominica',
    offset: -4,
  },
  {
    name: 'America/Edmonton',
    value: 'America/Edmonton',
    offset: -6,
  },
  {
    name: 'America/Eirunepe',
    value: 'America/Eirunepe',
    offset: -5,
  },
  {
    name: 'America/El Salvador',
    value: 'America/El_Salvador',
    offset: -6,
  },
  {
    name: 'America/Fort Nelson',
    value: 'America/Fort_Nelson',
    offset: -7,
  },
  {
    name: 'America/Fortaleza',
    value: 'America/Fortaleza',
    offset: -3,
  },
  {
    name: 'America/Glace Bay',
    value: 'America/Glace_Bay',
    offset: -3,
  },
  {
    name: 'America/Goose Bay',
    value: 'America/Goose_Bay',
    offset: -3,
  },
  {
    name: 'America/Grand Turk',
    value: 'America/Grand_Turk',
    offset: -4,
  },
  {
    name: 'America/Grenada',
    value: 'America/Grenada',
    offset: -4,
  },
  {
    name: 'America/Guadeloupe',
    value: 'America/Guadeloupe',
    offset: -4,
  },
  {
    name: 'America/Guatemala',
    value: 'America/Guatemala',
    offset: -6,
  },
  {
    name: 'America/Guayaquil',
    value: 'America/Guayaquil',
    offset: -5,
  },
  {
    name: 'America/Guyana',
    value: 'America/Guyana',
    offset: -4,
  },
  {
    name: 'America/Halifax',
    value: 'America/Halifax',
    offset: -3,
  },
  {
    name: 'America/Havana',
    value: 'America/Havana',
    offset: -4,
  },
  {
    name: 'America/Hermosillo',
    value: 'America/Hermosillo',
    offset: -7,
  },
  {
    name: 'America/Indiana/Indianapolis',
    value: 'America/Indiana/Indianapolis',
    offset: -4,
  },
  {
    name: 'America/Indiana/Knox',
    value: 'America/Indiana/Knox',
    offset: -5,
  },
  {
    name: 'America/Indiana/Marengo',
    value: 'America/Indiana/Marengo',
    offset: -4,
  },
  {
    name: 'America/Indiana/Petersburg',
    value: 'America/Indiana/Petersburg',
    offset: -4,
  },
  {
    name: 'America/Indiana/Tell City',
    value: 'America/Indiana/Tell_City',
    offset: -5,
  },
  {
    name: 'America/Indiana/Vevay',
    value: 'America/Indiana/Vevay',
    offset: -4,
  },
  {
    name: 'America/Indiana/Vincennes',
    value: 'America/Indiana/Vincennes',
    offset: -4,
  },
  {
    name: 'America/Indiana/Winamac',
    value: 'America/Indiana/Winamac',
    offset: -4,
  },
  {
    name: 'America/Inuvik',
    value: 'America/Inuvik',
    offset: -6,
  },
  {
    name: 'America/Iqaluit',
    value: 'America/Iqaluit',
    offset: -4,
  },
  {
    name: 'America/Jamaica',
    value: 'America/Jamaica',
    offset: -5,
  },
  {
    name: 'America/Juneau',
    value: 'America/Juneau',
    offset: -8,
  },
  {
    name: 'America/Kentucky/Louisville',
    value: 'America/Kentucky/Louisville',
    offset: -4,
  },
  {
    name: 'America/Kentucky/Monticello',
    value: 'America/Kentucky/Monticello',
    offset: -4,
  },
  {
    name: 'America/Kralendijk',
    value: 'America/Kralendijk',
    offset: -4,
  },
  {
    name: 'America/La Paz',
    value: 'America/La_Paz',
    offset: -4,
  },
  {
    name: 'America/Lima',
    value: 'America/Lima',
    offset: -5,
  },
  {
    name: 'America/Los Angeles',
    value: 'America/Los_Angeles',
    offset: -7,
  },
  {
    name: 'America/Lower Princes',
    value: 'America/Lower_Princes',
    offset: -4,
  },
  {
    name: 'America/Maceio',
    value: 'America/Maceio',
    offset: -3,
  },
  {
    name: 'America/Managua',
    value: 'America/Managua',
    offset: -6,
  },
  {
    name: 'America/Manaus',
    value: 'America/Manaus',
    offset: -4,
  },
  {
    name: 'America/Marigot',
    value: 'America/Marigot',
    offset: -4,
  },
  {
    name: 'America/Martinique',
    value: 'America/Martinique',
    offset: -4,
  },
  {
    name: 'America/Matamoros',
    value: 'America/Matamoros',
    offset: -5,
  },
  {
    name: 'America/Mazatlan',
    value: 'America/Mazatlan',
    offset: -6,
  },
  {
    name: 'America/Menominee',
    value: 'America/Menominee',
    offset: -5,
  },
  {
    name: 'America/Merida',
    value: 'America/Merida',
    offset: -5,
  },
  {
    name: 'America/Metlakatla',
    value: 'America/Metlakatla',
    offset: -8,
  },
  {
    name: 'America/Mexico City',
    value: 'America/Mexico_City',
    offset: -5,
  },
  {
    name: 'America/Miquelon',
    value: 'America/Miquelon',
    offset: -2,
  },
  {
    name: 'America/Moncton',
    value: 'America/Moncton',
    offset: -3,
  },
  {
    name: 'America/Monterrey',
    value: 'America/Monterrey',
    offset: -5,
  },
  {
    name: 'America/Montevideo',
    value: 'America/Montevideo',
    offset: -3,
  },
  {
    name: 'America/Montserrat',
    value: 'America/Montserrat',
    offset: -4,
  },
  {
    name: 'America/Nassau',
    value: 'America/Nassau',
    offset: -4,
  },
  {
    name: 'America/New York',
    value: 'America/New_York',
    offset: -4,
  },
  {
    name: 'America/Nipigon',
    value: 'America/Nipigon',
    offset: -4,
  },
  {
    name: 'America/Nome',
    value: 'America/Nome',
    offset: -8,
  },
  {
    name: 'America/Noronha',
    value: 'America/Noronha',
    offset: -2,
  },
  {
    name: 'America/North Dakota/Beulah',
    value: 'America/North_Dakota/Beulah',
    offset: -5,
  },
  {
    name: 'America/North Dakota/Center',
    value: 'America/North_Dakota/Center',
    offset: -5,
  },
  {
    name: 'America/North Dakota/New Salem',
    value: 'America/North_Dakota/New_Salem',
    offset: -5,
  },
  {
    name: 'America/Nuuk',
    value: 'America/Nuuk',
    offset: -2,
  },
  {
    name: 'America/Ojinaga',
    value: 'America/Ojinaga',
    offset: -6,
  },
  {
    name: 'America/Panama',
    value: 'America/Panama',
    offset: -5,
  },
  {
    name: 'America/Pangnirtung',
    value: 'America/Pangnirtung',
    offset: -4,
  },
  {
    name: 'America/Paramaribo',
    value: 'America/Paramaribo',
    offset: -3,
  },
  {
    name: 'America/Phoenix',
    value: 'America/Phoenix',
    offset: -7,
  },
  {
    name: 'America/Port-au-Prince',
    value: 'America/Port-au-Prince',
    offset: -4,
  },
  {
    name: 'America/Port of Spain',
    value: 'America/Port_of_Spain',
    offset: -4,
  },
  {
    name: 'America/Porto Velho',
    value: 'America/Porto_Velho',
    offset: -4,
  },
  {
    name: 'America/Puerto Rico',
    value: 'America/Puerto_Rico',
    offset: -4,
  },
  {
    name: 'America/Punta Arenas',
    value: 'America/Punta_Arenas',
    offset: -3,
  },
  {
    name: 'America/Rainy River',
    value: 'America/Rainy_River',
    offset: -5,
  },
  {
    name: 'America/Rankin Inlet',
    value: 'America/Rankin_Inlet',
    offset: -5,
  },
  {
    name: 'America/Recife',
    value: 'America/Recife',
    offset: -3,
  },
  {
    name: 'America/Regina',
    value: 'America/Regina',
    offset: -6,
  },
  {
    name: 'America/Resolute',
    value: 'America/Resolute',
    offset: -5,
  },
  {
    name: 'America/Rio Branco',
    value: 'America/Rio_Branco',
    offset: -5,
  },
  {
    name: 'America/Santarem',
    value: 'America/Santarem',
    offset: -3,
  },
  {
    name: 'America/Santiago',
    value: 'America/Santiago',
    offset: -4,
  },
  {
    name: 'America/Santo Domingo',
    value: 'America/Santo_Domingo',
    offset: -4,
  },
  {
    name: 'America/Sao Paulo',
    value: 'America/Sao_Paulo',
    offset: -3,
  },
  {
    name: 'America/Scoresbysund',
    value: 'America/Scoresbysund',
    offset: 0,
  },
  {
    name: 'America/Sitka',
    value: 'America/Sitka',
    offset: -8,
  },
  {
    name: 'America/St Barthelemy',
    value: 'America/St_Barthelemy',
    offset: -4,
  },
  {
    name: 'America/St Johns',
    value: 'America/St_Johns',
    offset: -2,
  },
  {
    name: 'America/St Kitts',
    value: 'America/St_Kitts',
    offset: -4,
  },
  {
    name: 'America/St Lucia',
    value: 'America/St_Lucia',
    offset: -4,
  },
  {
    name: 'America/St Thomas',
    value: 'America/St_Thomas',
    offset: -4,
  },
  {
    name: 'America/St Vincent',
    value: 'America/St_Vincent',
    offset: -4,
  },
  {
    name: 'America/Swift Current',
    value: 'America/Swift_Current',
    offset: -6,
  },
  {
    name: 'America/Tegucigalpa',
    value: 'America/Tegucigalpa',
    offset: -6,
  },
  {
    name: 'America/Thule',
    value: 'America/Thule',
    offset: -3,
  },
  {
    name: 'America/Thunder Bay',
    value: 'America/Thunder_Bay',
    offset: -4,
  },
  {
    name: 'America/Tijuana',
    value: 'America/Tijuana',
    offset: -7,
  },
  {
    name: 'America/Toronto',
    value: 'America/Toronto',
    offset: -4,
  },
  {
    name: 'America/Tortola',
    value: 'America/Tortola',
    offset: -4,
  },
  {
    name: 'America/Vancouver',
    value: 'America/Vancouver',
    offset: -7,
  },
  {
    name: 'America/Whitehorse',
    value: 'America/Whitehorse',
    offset: -7,
  },
  {
    name: 'America/Winnipeg',
    value: 'America/Winnipeg',
    offset: -5,
  },
  {
    name: 'America/Yakutat',
    value: 'America/Yakutat',
    offset: -8,
  },
  {
    name: 'America/Yellowknife',
    value: 'America/Yellowknife',
    offset: -6,
  },
  {
    name: 'Antarctica/Casey',
    value: 'Antarctica/Casey',
    offset: 8,
  },
  {
    name: 'Antarctica/Davis',
    value: 'Antarctica/Davis',
    offset: 7,
  },
  {
    name: 'Antarctica/DumontDUrville',
    value: 'Antarctica/DumontDUrville',
    offset: 10,
  },
  {
    name: 'Antarctica/Macquarie',
    value: 'Antarctica/Macquarie',
    offset: 11,
  },
  {
    name: 'Antarctica/Mawson',
    value: 'Antarctica/Mawson',
    offset: 5,
  },
  {
    name: 'Antarctica/McMurdo',
    value: 'Antarctica/McMurdo',
    offset: 12,
  },
  {
    name: 'Antarctica/Palmer',
    value: 'Antarctica/Palmer',
    offset: -3,
  },
  {
    name: 'Antarctica/Rothera',
    value: 'Antarctica/Rothera',
    offset: -3,
  },
  {
    name: 'Antarctica/Syowa',
    value: 'Antarctica/Syowa',
    offset: 3,
  },
  {
    name: 'Antarctica/Troll',
    value: 'Antarctica/Troll',
    offset: 2,
  },
  {
    name: 'Antarctica/Vostok',
    value: 'Antarctica/Vostok',
    offset: 6,
  },
  {
    name: 'Arctic/Longyearbyen',
    value: 'Arctic/Longyearbyen',
    offset: 2,
  },
  {
    name: 'Asia/Aden',
    value: 'Asia/Aden',
    offset: 3,
  },
  {
    name: 'Asia/Almaty',
    value: 'Asia/Almaty',
    offset: 6,
  },
  {
    name: 'Asia/Amman',
    value: 'Asia/Amman',
    offset: 3,
  },
  {
    name: 'Asia/Anadyr',
    value: 'Asia/Anadyr',
    offset: 12,
  },
  {
    name: 'Asia/Aqtau',
    value: 'Asia/Aqtau',
    offset: 5,
  },
  {
    name: 'Asia/Aqtobe',
    value: 'Asia/Aqtobe',
    offset: 5,
  },
  {
    name: 'Asia/Ashgabat',
    value: 'Asia/Ashgabat',
    offset: 5,
  },
  {
    name: 'Asia/Atyrau',
    value: 'Asia/Atyrau',
    offset: 5,
  },
  {
    name: 'Asia/Baghdad',
    value: 'Asia/Baghdad',
    offset: 3,
  },
  {
    name: 'Asia/Bahrain',
    value: 'Asia/Bahrain',
    offset: 3,
  },
  {
    name: 'Asia/Baku',
    value: 'Asia/Baku',
    offset: 4,
  },
  {
    name: 'Asia/Bangkok',
    value: 'Asia/Bangkok',
    offset: 7,
  },
  {
    name: 'Asia/Barnaul',
    value: 'Asia/Barnaul',
    offset: 7,
  },
  {
    name: 'Asia/Beirut',
    value: 'Asia/Beirut',
    offset: 3,
  },
  {
    name: 'Asia/Bishkek',
    value: 'Asia/Bishkek',
    offset: 6,
  },
  {
    name: 'Asia/Brunei',
    value: 'Asia/Brunei',
    offset: 8,
  },
  {
    name: 'Asia/Chita',
    value: 'Asia/Chita',
    offset: 9,
  },
  {
    name: 'Asia/Choibalsan',
    value: 'Asia/Choibalsan',
    offset: 8,
  },
  {
    name: 'Asia/Colombo',
    value: 'Asia/Colombo',
    offset: 5,
  },
  {
    name: 'Asia/Damascus',
    value: 'Asia/Damascus',
    offset: 3,
  },
  {
    name: 'Asia/Dhaka',
    value: 'Asia/Dhaka',
    offset: 6,
  },
  {
    name: 'Asia/Dili',
    value: 'Asia/Dili',
    offset: 9,
  },
  {
    name: 'Asia/Dubai',
    value: 'Asia/Dubai',
    offset: 4,
  },
  {
    name: 'Asia/Dushanbe',
    value: 'Asia/Dushanbe',
    offset: 5,
  },
  {
    name: 'Asia/Famagusta',
    value: 'Asia/Famagusta',
    offset: 3,
  },
  {
    name: 'Asia/Gaza',
    value: 'Asia/Gaza',
    offset: 3,
  },
  {
    name: 'Asia/Hebron',
    value: 'Asia/Hebron',
    offset: 3,
  },
  {
    name: 'Asia/Ho Chi Minh',
    value: 'Asia/Ho_Chi_Minh',
    offset: 7,
  },
  {
    name: 'Asia/Hong Kong',
    value: 'Asia/Hong_Kong',
    offset: 8,
  },
  {
    name: 'Asia/Hovd',
    value: 'Asia/Hovd',
    offset: 7,
  },
  {
    name: 'Asia/Irkutsk',
    value: 'Asia/Irkutsk',
    offset: 8,
  },
  {
    name: 'Asia/Jakarta',
    value: 'Asia/Jakarta',
    offset: 7,
  },
  {
    name: 'Asia/Jayapura',
    value: 'Asia/Jayapura',
    offset: 9,
  },
  {
    name: 'Asia/Jerusalem',
    value: 'Asia/Jerusalem',
    offset: 3,
  },
  {
    name: 'Asia/Kabul',
    value: 'Asia/Kabul',
    offset: 4,
  },
  {
    name: 'Asia/Kamchatka',
    value: 'Asia/Kamchatka',
    offset: 12,
  },
  {
    name: 'Asia/Karachi',
    value: 'Asia/Karachi',
    offset: 5,
  },
  {
    name: 'Asia/Kathmandu',
    value: 'Asia/Kathmandu',
    offset: 5,
  },
  {
    name: 'Asia/Khandyga',
    value: 'Asia/Khandyga',
    offset: 9,
  },
  {
    name: 'Asia/Kolkata',
    value: 'Asia/Kolkata',
    offset: 5,
  },
  {
    name: 'Asia/Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
    offset: 7,
  },
  {
    name: 'Asia/Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur',
    offset: 8,
  },
  {
    name: 'Asia/Kuching',
    value: 'Asia/Kuching',
    offset: 8,
  },
  {
    name: 'Asia/Kuwait',
    value: 'Asia/Kuwait',
    offset: 3,
  },
  {
    name: 'Asia/Macau',
    value: 'Asia/Macau',
    offset: 8,
  },
  {
    name: 'Asia/Magadan',
    value: 'Asia/Magadan',
    offset: 11,
  },
  {
    name: 'Asia/Makassar',
    value: 'Asia/Makassar',
    offset: 8,
  },
  {
    name: 'Asia/Manila',
    value: 'Asia/Manila',
    offset: 8,
  },
  {
    name: 'Asia/Muscat',
    value: 'Asia/Muscat',
    offset: 4,
  },
  {
    name: 'Asia/Nicosia',
    value: 'Asia/Nicosia',
    offset: 3,
  },
  {
    name: 'Asia/Novokuznetsk',
    value: 'Asia/Novokuznetsk',
    offset: 7,
  },
  {
    name: 'Asia/Novosibirsk',
    value: 'Asia/Novosibirsk',
    offset: 7,
  },
  {
    name: 'Asia/Omsk',
    value: 'Asia/Omsk',
    offset: 6,
  },
  {
    name: 'Asia/Oral',
    value: 'Asia/Oral',
    offset: 5,
  },
  {
    name: 'Asia/Phnom Penh',
    value: 'Asia/Phnom_Penh',
    offset: 7,
  },
  {
    name: 'Asia/Pontianak',
    value: 'Asia/Pontianak',
    offset: 7,
  },
  {
    name: 'Asia/Pyongyang',
    value: 'Asia/Pyongyang',
    offset: 9,
  },
  {
    name: 'Asia/Qatar',
    value: 'Asia/Qatar',
    offset: 3,
  },
  {
    name: 'Asia/Qostanay',
    value: 'Asia/Qostanay',
    offset: 6,
  },
  {
    name: 'Asia/Qyzylorda',
    value: 'Asia/Qyzylorda',
    offset: 5,
  },
  {
    name: 'Asia/Riyadh',
    value: 'Asia/Riyadh',
    offset: 3,
  },
  {
    name: 'Asia/Sakhalin',
    value: 'Asia/Sakhalin',
    offset: 11,
  },
  {
    name: 'Asia/Samarkand',
    value: 'Asia/Samarkand',
    offset: 5,
  },
  {
    name: 'Asia/Seoul',
    value: 'Asia/Seoul',
    offset: 9,
  },
  {
    name: 'Asia/Shanghai',
    value: 'Asia/Shanghai',
    offset: 8,
  },
  {
    name: 'Asia/Singapore',
    value: 'Asia/Singapore',
    offset: 8,
  },
  {
    name: 'Asia/Srednekolymsk',
    value: 'Asia/Srednekolymsk',
    offset: 11,
  },
  {
    name: 'Asia/Taipei',
    value: 'Asia/Taipei',
    offset: 8,
  },
  {
    name: 'Asia/Tashkent',
    value: 'Asia/Tashkent',
    offset: 5,
  },
  {
    name: 'Asia/Tbilisi',
    value: 'Asia/Tbilisi',
    offset: 4,
  },
  {
    name: 'Asia/Tehran',
    value: 'Asia/Tehran',
    offset: 4,
  },
  {
    name: 'Asia/Thimphu',
    value: 'Asia/Thimphu',
    offset: 6,
  },
  {
    name: 'Asia/Tokyo',
    value: 'Asia/Tokyo',
    offset: 9,
  },
  {
    name: 'Asia/Tomsk',
    value: 'Asia/Tomsk',
    offset: 7,
  },
  {
    name: 'Asia/Ulaanbaatar',
    value: 'Asia/Ulaanbaatar',
    offset: 8,
  },
  {
    name: 'Asia/Urumqi',
    value: 'Asia/Urumqi',
    offset: 6,
  },
  {
    name: 'Asia/Ust-Nera',
    value: 'Asia/Ust-Nera',
    offset: 10,
  },
  {
    name: 'Asia/Vientiane',
    value: 'Asia/Vientiane',
    offset: 7,
  },
  {
    name: 'Asia/Vladivostok',
    value: 'Asia/Vladivostok',
    offset: 10,
  },
  {
    name: 'Asia/Yakutsk',
    value: 'Asia/Yakutsk',
    offset: 9,
  },
  {
    name: 'Asia/Yangon',
    value: 'Asia/Yangon',
    offset: 6,
  },
  {
    name: 'Asia/Yekaterinburg',
    value: 'Asia/Yekaterinburg',
    offset: 5,
  },
  {
    name: 'Asia/Yerevan',
    value: 'Asia/Yerevan',
    offset: 4,
  },
  {
    name: 'Atlantic/Azores',
    value: 'Atlantic/Azores',
    offset: 0,
  },
  {
    name: 'Atlantic/Bermuda',
    value: 'Atlantic/Bermuda',
    offset: -3,
  },
  {
    name: 'Atlantic/Canary',
    value: 'Atlantic/Canary',
    offset: 1,
  },
  {
    name: 'Atlantic/Cape Verde',
    value: 'Atlantic/Cape_Verde',
    offset: -1,
  },
  {
    name: 'Atlantic/Faroe',
    value: 'Atlantic/Faroe',
    offset: 1,
  },
  {
    name: 'Atlantic/Madeira',
    value: 'Atlantic/Madeira',
    offset: 1,
  },
  {
    name: 'Atlantic/Reykjavik',
    value: 'Atlantic/Reykjavik',
    offset: 0,
  },
  {
    name: 'Atlantic/South Georgia',
    value: 'Atlantic/South_Georgia',
    offset: -2,
  },
  {
    name: 'Atlantic/St Helena',
    value: 'Atlantic/St_Helena',
    offset: 0,
  },
  {
    name: 'Atlantic/Stanley',
    value: 'Atlantic/Stanley',
    offset: -3,
  },
  {
    name: 'Australia/Adelaide',
    value: 'Australia/Adelaide',
    offset: 9,
  },
  {
    name: 'Australia/Brisbane',
    value: 'Australia/Brisbane',
    offset: 10,
  },
  {
    name: 'Australia/Broken Hill',
    value: 'Australia/Broken_Hill',
    offset: 9,
  },
  {
    name: 'Australia/Currie',
    value: 'Australia/Currie',
    offset: 10,
  },
  {
    name: 'Australia/Darwin',
    value: 'Australia/Darwin',
    offset: 9,
  },
  {
    name: 'Australia/Eucla',
    value: 'Australia/Eucla',
    offset: 8,
  },
  {
    name: 'Australia/Hobart',
    value: 'Australia/Hobart',
    offset: 10,
  },
  {
    name: 'Australia/Lindeman',
    value: 'Australia/Lindeman',
    offset: 10,
  },
  {
    name: 'Australia/Lord Howe',
    value: 'Australia/Lord_Howe',
    offset: 10,
  },
  {
    name: 'Australia/Melbourne',
    value: 'Australia/Melbourne',
    offset: 10,
  },
  {
    name: 'Australia/Perth',
    value: 'Australia/Perth',
    offset: 8,
  },
  {
    name: 'Australia/Sydney',
    value: 'Australia/Sydney',
    offset: 10,
  },
  {
    name: 'Canada/Atlantic',
    value: 'Canada/Atlantic',
    offset: -3,
  },
  {
    name: 'Canada/Central',
    value: 'Canada/Central',
    offset: -5,
  },
  {
    name: 'Canada/Eastern',
    value: 'Canada/Eastern',
    offset: -4,
  },
  {
    name: 'Canada/Mountain',
    value: 'Canada/Mountain',
    offset: -6,
  },
  {
    name: 'Canada/Newfoundland',
    value: 'Canada/Newfoundland',
    offset: -2,
  },
  {
    name: 'Canada/Pacific',
    value: 'Canada/Pacific',
    offset: -7,
  },
  {
    name: 'Canada/Saskatchewan',
    value: 'Canada/Saskatchewan',
    offset: -6,
  },
  {
    name: 'Europe/Amsterdam',
    value: 'Europe/Amsterdam',
    offset: 2,
  },
  {
    name: 'Europe/Andorra',
    value: 'Europe/Andorra',
    offset: 2,
  },
  {
    name: 'Europe/Astrakhan',
    value: 'Europe/Astrakhan',
    offset: 4,
  },
  {
    name: 'Europe/Athens',
    value: 'Europe/Athens',
    offset: 3,
  },
  {
    name: 'Europe/Belgrade',
    value: 'Europe/Belgrade',
    offset: 2,
  },
  {
    name: 'Europe/Berlin',
    value: 'Europe/Berlin',
    offset: 2,
  },
  {
    name: 'Europe/Bratislava',
    value: 'Europe/Bratislava',
    offset: 2,
  },
  {
    name: 'Europe/Brussels',
    value: 'Europe/Brussels',
    offset: 2,
  },
  {
    name: 'Europe/Bucharest',
    value: 'Europe/Bucharest',
    offset: 3,
  },
  {
    name: 'Europe/Budapest',
    value: 'Europe/Budapest',
    offset: 2,
  },
  {
    name: 'Europe/Busingen',
    value: 'Europe/Busingen',
    offset: 2,
  },
  {
    name: 'Europe/Chisinau',
    value: 'Europe/Chisinau',
    offset: 3,
  },
  {
    name: 'Europe/Copenhagen',
    value: 'Europe/Copenhagen',
    offset: 2,
  },
  {
    name: 'Europe/Dublin',
    value: 'Europe/Dublin',
    offset: 1,
  },
  {
    name: 'Europe/Gibraltar',
    value: 'Europe/Gibraltar',
    offset: 2,
  },
  {
    name: 'Europe/Guernsey',
    value: 'Europe/Guernsey',
    offset: 1,
  },
  {
    name: 'Europe/Helsinki',
    value: 'Europe/Helsinki',
    offset: 3,
  },
  {
    name: 'Europe/Isle of Man',
    value: 'Europe/Isle_of_Man',
    offset: 1,
  },
  {
    name: 'Europe/Istanbul',
    value: 'Europe/Istanbul',
    offset: 3,
  },
  {
    name: 'Europe/Jersey',
    value: 'Europe/Jersey',
    offset: 1,
  },
  {
    name: 'Europe/Kaliningrad',
    value: 'Europe/Kaliningrad',
    offset: 2,
  },
  {
    name: 'Europe/Kiev',
    value: 'Europe/Kiev',
    offset: 3,
  },
  {
    name: 'Europe/Kirov',
    value: 'Europe/Kirov',
    offset: 3,
  },
  {
    name: 'Europe/Lisbon',
    value: 'Europe/Lisbon',
    offset: 1,
  },
  {
    name: 'Europe/Ljubljana',
    value: 'Europe/Ljubljana',
    offset: 2,
  },
  {
    name: 'Europe/London',
    value: 'Europe/London',
    offset: 1,
  },
  {
    name: 'Europe/Luxembourg',
    value: 'Europe/Luxembourg',
    offset: 2,
  },
  {
    name: 'Europe/Madrid',
    value: 'Europe/Madrid',
    offset: 2,
  },
  {
    name: 'Europe/Malta',
    value: 'Europe/Malta',
    offset: 2,
  },
  {
    name: 'Europe/Mariehamn',
    value: 'Europe/Mariehamn',
    offset: 3,
  },
  {
    name: 'Europe/Minsk',
    value: 'Europe/Minsk',
    offset: 3,
  },
  {
    name: 'Europe/Monaco',
    value: 'Europe/Monaco',
    offset: 2,
  },
  {
    name: 'Europe/Moscow',
    value: 'Europe/Moscow',
    offset: 3,
  },
  {
    name: 'Europe/Oslo',
    value: 'Europe/Oslo',
    offset: 2,
  },
  {
    name: 'Europe/Paris',
    value: 'Europe/Paris',
    offset: 2,
  },
  {
    name: 'Europe/Podgorica',
    value: 'Europe/Podgorica',
    offset: 2,
  },
  {
    name: 'Europe/Prague',
    value: 'Europe/Prague',
    offset: 2,
  },
  {
    name: 'Europe/Riga',
    value: 'Europe/Riga',
    offset: 3,
  },
  {
    name: 'Europe/Rome',
    value: 'Europe/Rome',
    offset: 2,
  },
  {
    name: 'Europe/Samara',
    value: 'Europe/Samara',
    offset: 4,
  },
  {
    name: 'Europe/San Marino',
    value: 'Europe/San_Marino',
    offset: 2,
  },
  {
    name: 'Europe/Sarajevo',
    value: 'Europe/Sarajevo',
    offset: 2,
  },
  {
    name: 'Europe/Saratov',
    value: 'Europe/Saratov',
    offset: 4,
  },
  {
    name: 'Europe/Simferopol',
    value: 'Europe/Simferopol',
    offset: 3,
  },
  {
    name: 'Europe/Skopje',
    value: 'Europe/Skopje',
    offset: 2,
  },
  {
    name: 'Europe/Sofia',
    value: 'Europe/Sofia',
    offset: 3,
  },
  {
    name: 'Europe/Stockholm',
    value: 'Europe/Stockholm',
    offset: 2,
  },
  {
    name: 'Europe/Tallinn',
    value: 'Europe/Tallinn',
    offset: 3,
  },
  {
    name: 'Europe/Tirane',
    value: 'Europe/Tirane',
    offset: 2,
  },
  {
    name: 'Europe/Ulyanovsk',
    value: 'Europe/Ulyanovsk',
    offset: 4,
  },
  {
    name: 'Europe/Uzhgorod',
    value: 'Europe/Uzhgorod',
    offset: 3,
  },
  {
    name: 'Europe/Vaduz',
    value: 'Europe/Vaduz',
    offset: 2,
  },
  {
    name: 'Europe/Vatican',
    value: 'Europe/Vatican',
    offset: 2,
  },
  {
    name: 'Europe/Vienna',
    value: 'Europe/Vienna',
    offset: 2,
  },
  {
    name: 'Europe/Vilnius',
    value: 'Europe/Vilnius',
    offset: 3,
  },
  {
    name: 'Europe/Volgograd',
    value: 'Europe/Volgograd',
    offset: 4,
  },
  {
    name: 'Europe/Warsaw',
    value: 'Europe/Warsaw',
    offset: 2,
  },
  {
    name: 'Europe/Zagreb',
    value: 'Europe/Zagreb',
    offset: 2,
  },
  {
    name: 'Europe/Zaporozhye',
    value: 'Europe/Zaporozhye',
    offset: 3,
  },
  {
    name: 'Europe/Zurich',
    value: 'Europe/Zurich',
    offset: 2,
  },
  {
    name: 'GMT',
    value: 'GMT',
    offset: 0,
  },
  {
    name: 'Indian/Antananarivo',
    value: 'Indian/Antananarivo',
    offset: 3,
  },
  {
    name: 'Indian/Chagos',
    value: 'Indian/Chagos',
    offset: 6,
  },
  {
    name: 'Indian/Christmas',
    value: 'Indian/Christmas',
    offset: 7,
  },
  {
    name: 'Indian/Cocos',
    value: 'Indian/Cocos',
    offset: 6,
  },
  {
    name: 'Indian/Comoro',
    value: 'Indian/Comoro',
    offset: 3,
  },
  {
    name: 'Indian/Kerguelen',
    value: 'Indian/Kerguelen',
    offset: 5,
  },
  {
    name: 'Indian/Mahe',
    value: 'Indian/Mahe',
    offset: 4,
  },
  {
    name: 'Indian/Maldives',
    value: 'Indian/Maldives',
    offset: 5,
  },
  {
    name: 'Indian/Mauritius',
    value: 'Indian/Mauritius',
    offset: 4,
  },
  {
    name: 'Indian/Mayotte',
    value: 'Indian/Mayotte',
    offset: 3,
  },
  {
    name: 'Indian/Reunion',
    value: 'Indian/Reunion',
    offset: 4,
  },
  {
    name: 'Pacific/Apia',
    value: 'Pacific/Apia',
    offset: 13,
  },
  {
    name: 'Pacific/Auckland',
    value: 'Pacific/Auckland',
    offset: 12,
  },
  {
    name: 'Pacific/Bougainville',
    value: 'Pacific/Bougainville',
    offset: 11,
  },
  {
    name: 'Pacific/Chatham',
    value: 'Pacific/Chatham',
    offset: 12,
  },
  {
    name: 'Pacific/Chuuk',
    value: 'Pacific/Chuuk',
    offset: 10,
  },
  {
    name: 'Pacific/Easter',
    value: 'Pacific/Easter',
    offset: -6,
  },
  {
    name: 'Pacific/Efate',
    value: 'Pacific/Efate',
    offset: 11,
  },
  {
    name: 'Pacific/Enderbury',
    value: 'Pacific/Enderbury',
    offset: 13,
  },
  {
    name: 'Pacific/Fakaofo',
    value: 'Pacific/Fakaofo',
    offset: 13,
  },
  {
    name: 'Pacific/Fiji',
    value: 'Pacific/Fiji',
    offset: 12,
  },
  {
    name: 'Pacific/Funafuti',
    value: 'Pacific/Funafuti',
    offset: 12,
  },
  {
    name: 'Pacific/Galapagos',
    value: 'Pacific/Galapagos',
    offset: -6,
  },
  {
    name: 'Pacific/Gambier',
    value: 'Pacific/Gambier',
    offset: -9,
  },
  {
    name: 'Pacific/Guadalcanal',
    value: 'Pacific/Guadalcanal',
    offset: 11,
  },
  {
    name: 'Pacific/Guam',
    value: 'Pacific/Guam',
    offset: 10,
  },
  {
    name: 'Pacific/Honolulu',
    value: 'Pacific/Honolulu',
    offset: -10,
  },
  {
    name: 'Pacific/Kiritimati',
    value: 'Pacific/Kiritimati',
    offset: 14,
  },
  {
    name: 'Pacific/Kosrae',
    value: 'Pacific/Kosrae',
    offset: 11,
  },
  {
    name: 'Pacific/Kwajalein',
    value: 'Pacific/Kwajalein',
    offset: 12,
  },
  {
    name: 'Pacific/Majuro',
    value: 'Pacific/Majuro',
    offset: 12,
  },
  {
    name: 'Pacific/Marquesas',
    value: 'Pacific/Marquesas',
    offset: -9,
  },
  {
    name: 'Pacific/Midway',
    value: 'Pacific/Midway',
    offset: -11,
  },
  {
    name: 'Pacific/Nauru',
    value: 'Pacific/Nauru',
    offset: 12,
  },
  {
    name: 'Pacific/Niue',
    value: 'Pacific/Niue',
    offset: -11,
  },
  {
    name: 'Pacific/Norfolk',
    value: 'Pacific/Norfolk',
    offset: 11,
  },
  {
    name: 'Pacific/Noumea',
    value: 'Pacific/Noumea',
    offset: 11,
  },
  {
    name: 'Pacific/Pago Pago',
    value: 'Pacific/Pago_Pago',
    offset: -11,
  },
  {
    name: 'Pacific/Palau',
    value: 'Pacific/Palau',
    offset: 9,
  },
  {
    name: 'Pacific/Pitcairn',
    value: 'Pacific/Pitcairn',
    offset: -8,
  },
  {
    name: 'Pacific/Pohnpei',
    value: 'Pacific/Pohnpei',
    offset: 11,
  },
  {
    name: 'Pacific/Port Moresby',
    value: 'Pacific/Port_Moresby',
    offset: 10,
  },
  {
    name: 'Pacific/Rarotonga',
    value: 'Pacific/Rarotonga',
    offset: -10,
  },
  {
    name: 'Pacific/Saipan',
    value: 'Pacific/Saipan',
    offset: 10,
  },
  {
    name: 'Pacific/Tahiti',
    value: 'Pacific/Tahiti',
    offset: -10,
  },
  {
    name: 'Pacific/Tarawa',
    value: 'Pacific/Tarawa',
    offset: 12,
  },
  {
    name: 'Pacific/Tongatapu',
    value: 'Pacific/Tongatapu',
    offset: 13,
  },
  {
    name: 'Pacific/Wake',
    value: 'Pacific/Wake',
    offset: 12,
  },
  {
    name: 'Pacific/Wallis',
    value: 'Pacific/Wallis',
    offset: 12,
  },
  {
    name: 'US/Alaska',
    value: 'US/Alaska',
    offset: -8,
  },
  {
    name: 'US/Arizona',
    value: 'US/Arizona',
    offset: -7,
  },
  {
    name: 'US/Central',
    value: 'US/Central',
    offset: -5,
  },
  {
    name: 'US/Eastern',
    value: 'US/Eastern',
    offset: -4,
  },
  {
    name: 'US/Hawaii',
    value: 'US/Hawaii',
    offset: -10,
  },
  {
    name: 'US/Mountain',
    value: 'US/Mountain',
    offset: -6,
  },
  {
    name: 'US/Pacific',
    value: 'US/Pacific',
    offset: -7,
  },
  {
    name: 'UTC',
    value: 'UTC',
    offset: 0,
  },
];
